import {
  BMC_BLOCKS,
  BMC_STAGES,
} from '../../common_components/bmc/bmc_constants';


const VISION_SUGGESTS = {
  [BMC_BLOCKS.CHANNELS]: {
    [BMC_STAGES.OBSERVATIONAL]: [{
      id: 0,
      name: 'v_ch_o_s1',
      description: 'v_ch_o_s1_d',
      purpose: 'data_collection',
    }, {
      id: 1,
      name: 'v_ch_o_s2',
      description: 'v_ch_o_s2_d',
      purpose: 'data_collection',
    }],
  },
  [BMC_BLOCKS.CUSTOMER_RELATIONSHIPS]: {
    [BMC_STAGES.OBSERVATIONAL]: [{
      id: 0,
      name: 'v_cr_o_s1',
      description: 'v_cr_o_s1_d',
      crPurpose: 'v_cr_o_s1_p',
      relation: 'get',
    }, {
      id: 1,
      name: 'v_cr_o_s2',
      description: 'v_cr_o_s2_d',
      crPurpose: 'v_cr_o_s2_p',
      relation: 'keep',
    }, {
      id: 2,
      name: 'v_cr_o_s3',
      description: 'v_cr_o_s3_d',
      crPurpose: 'v_cr_o_s3_p',
      relation: 'grow',
    }],
  },
  [BMC_BLOCKS.KEY_ACTIVITIES]: {
    [BMC_STAGES.OBSERVATIONAL]: [{
      id: 0,
      name: 'v_ka_o_s1',
      description: 'v_ka_o_s1_d',
    }, {
      id: 1,
      name: 'v_ka_o_s2',
      description: 'v_ka_o_s2_d',
    }],
  },
  [BMC_BLOCKS.KEY_RESOURCES]: {
    [BMC_STAGES.OBSERVATIONAL]: [{
      id: 0,
      name: 'v_kr_o_s1',
      description: 'v_kr_o_s1_d',
    }, {
      id: 1,
      name: 'v_kr_o_s2',
      description: 'v_kr_o_s2_d',
    }],
  },
  [BMC_BLOCKS.KEY_PARTNERS]: {
    [BMC_STAGES.OBSERVATIONAL]: [{
      id: 0,
      name: 'v_kep_o_s1',
      description: 'v_kep_o_s1_d',
    }, {
      id: 1,
      name: 'v_kep_o_s2',
      description: 'v_kep_o_s2_d',
    }],
  },
  [BMC_BLOCKS.COST_STRUCTURE]: {
    [BMC_STAGES.OBSERVATIONAL]: [{
      id: 0,
      name: 'v_cos_o_s1',
      description: 'v_cos_o_s1_d',
    }, {
      id: 1,
      name: 'v_cos_o_s2',
      description: 'v_cos_o_s2_d',
    }],
  },
  [BMC_BLOCKS.REVENUE_STREAMS]: {
    [BMC_STAGES.OBSERVATIONAL]: [{
      id: 0,
      name: 'v_rs_o_s1',
      description: 'v_rs_o_s1_d',
    }, {
      id: 1,
      name: 'v_rs_o_s2',
      description: 'v_rs_o_s2_d',
    }],
  },
  [BMC_BLOCKS.CUSTOMER_SEGMENTS]: {
    [BMC_STAGES.OBSERVATIONAL]: [{
      id: 0,
      name: 'v_cs_o_s1',
      description: 'v_cs_o_s1_d',
    }],
  },
};


const SUGGESTS = {


  [BMC_BLOCKS.CHANNELS]: {
    [BMC_STAGES.OBSERVATIONAL]: [{
      id: 0,
      name: 'ch_o_s1',
      description: 'ch_o_s1_d',
      purpose: 'data_collection',
    }, {
      id: 1,
      name: 'ch_o_s2',
      description: 'ch_o_s2_d',
      purpose: 'data_collection',
    }],
    [BMC_STAGES.FIRST_USER]: [{
      id: 0,
      name: 'ch_fu_s1',
      description: 'ch_fu_s1_d',
      purpose: 'awareness',
    }, {
      id: 1,
      name: 'ch_fu_s2',
      description: 'ch_fu_s2_d',
      purpose: 'awareness',
    }, {
      id: 2,
      name: 'ch_fu_s3',
      description: 'ch_fu_s3_d',
      purpose: 'evaluation',
    }],
    [BMC_STAGES.FIRST_GROUP]: [{
      id: 0,
      name: 'ch_fg_s1',
      description: 'ch_fg_s1_d',
      purpose: 'purchase',
    }, {
      id: 1,
      name: 'ch_fg_s2',
      description: 'ch_fg_s2_d',
      purpose: 'purchase',
    }],
    [BMC_STAGES.FOCUS_GROUP]: [{
      id: 0,
      name: 'ch_fcg_s1',
      description: 'ch_fcg_s1_d',
      purpose: 'purchase',
    }, {
      id: 1,
      name: 'ch_fcg_s2',
      description: 'ch_fcg_s2_d',
      purpose: 'awareness',
    }],
    [BMC_STAGES.KNOW_HOW]: [{
      id: 0,
      name: 'ch_kh_s1',
      description: 'ch_kh_s1_d',
      purpose: 'awareness',
    }, {
      id: 1,
      name: 'ch_kh_s2',
      description: 'ch_kh_s2_d',
      purpose: 'evaluation',
    }],
    [BMC_STAGES.EARLY_ADOPTERS]: [{
      id: 0,
      name: 'ch_ea_s1',
      description: 'ch_ea_s1_d',
      purpose: 'purchase',
    }, {
      id: 1,
      name: 'ch_ea_s2',
      description: 'ch_ea_s2_d',
      purpose: 'awareness',
    }],
    [BMC_STAGES.FIRST_CLIENT]: [{
      id: 0,
      name: 'ch_fc_s1',
      description: 'ch_fc_s1_d',
      purpose: 'purchase',
    }, {
      id: 1,
      name: 'ch_fc_s2',
      description: 'ch_fc_s2_d',
      purpose: 'evaluation',
    }],
    [BMC_STAGES.FREE]: [{
      id: 0,
      name: 'ch_f_s1',
      description: 'ch_f_s1_d',
    }, {
      id: 1,
      name: 'ch_f_s2',
      description: 'ch_f_s2_d',
    }],

  },


  [BMC_BLOCKS.CUSTOMER_RELATIONSHIPS]: {
    [BMC_STAGES.OBSERVATIONAL]: [{
      id: 0,
      name: 'cr_o_s1',
      description: 'cr_o_s1_d',
      crPurpose: 'cr_o_s1_p',
      relation: 'get',
    }, {
      id: 1,
      name: 'cr_o_s2',
      description: 'cr_o_s2_d',
      crPurpose: 'cr_o_s2_p',
      relation: 'keep',
    }, {
      id: 2,
      name: 'cr_o_s3',
      description: 'cr_o_s3_d',
      crPurpose: 'cr_o_s3_p',
      relation: 'grow',
    }],
    [BMC_STAGES.FIRST_USER]: [{
      id: 0,
      name: 'cr_fu_s1',
      description: 'cr_fu_s1_d',
      crPurpose: 'cr_fu_s1_p',
      relation: 'get',
    }, {
      id: 1,
      name: 'cr_fu_s2',
      description: 'cr_fu_s2_d',
      crPurpose: 'cr_fu_s2_p',
      relation: 'keep',
    }, {
      id: 2,
      name: 'cr_fu_s3',
      description: 'cr_fu_s3_d',
      crPurpose: 'cr_fu_s3_p',
      relation: 'grow',
    }],
    [BMC_STAGES.FIRST_GROUP]: [{
      id: 0,
      name: 'cr_fg_s1',
      description: 'cr_fg_s1_d',
      crPurpose: 'cr_fg_s1_p',
      relation: 'get',
    }, {
      id: 1,
      name: 'cr_fg_s2',
      description: 'cr_fg_s2_d',
      crPurpose: 'cr_fg_s2_p',
      relation: 'keep',
    }, {
      id: 2,
      name: 'cr_fg_s3',
      description: 'cr_fg_s3_d',
      crPurpose: 'cr_fg_s3_p',
      relation: 'grow',
    }],
    [BMC_STAGES.FOCUS_GROUP]: [{
      id: 0,
      name: 'cr_fcg_s1',
      description: 'cr_fcg_s1_d',
      crPurpose: 'cr_fcg_s1_p',
      relation: 'get',
    }, {
      id: 1,
      name: 'cr_fcg_s2',
      description: 'cr_fcg_s2_d',
      crPurpose: 'cr_fcg_s1_p',
      relation: 'keep',
    }, {
      id: 2,
      name: 'cr_fcg_s3',
      description: 'cr_fcg_s3_d',
      crPurpose: 'cr_fcg_s1_p',
      relation: 'grow',
    }],
    [BMC_STAGES.KNOW_HOW]: [{
      id: 0,
      name: 'cr_kh_s1',
      description: 'cr_kh_s1_d',
      crPurpose: 'cr_kh_s1_p',
      relation: 'get',
    }, {
      id: 1,
      name: 'cr_kh_s2',
      description: 'cr_kh_s2_d',
      crPurpose: 'cr_kh_s2_p',
      relation: 'keep',
    }, {
      id: 2,
      name: 'cr_kh_s3',
      description: 'cr_kh_s3_d',
      crPurpose: 'cr_kh_s3_p',
      relation: 'grow',
    }],
    [BMC_STAGES.EARLY_ADOPTERS]: [{
      id: 0,
      name: 'cr_ea_s1',
      description: 'cr_ea_s1_d',
      crPurpose: 'cr_ea_s1_p',
      relation: 'get',
    }, {
      id: 1,
      name: 'cr_ea_s2',
      description: 'cr_ea_s2_d',
      crPurpose: 'cr_ea_s2_p',
      relation: 'keep',
    }, {
      id: 2,
      name: 'cr_ea_s3',
      description: 'cr_ea_s3_d',
      crPurpose: 'cr_ea_s3_p',
      relation: 'grow',
    }],
    [BMC_STAGES.FIRST_CLIENT]: [{
      id: 0,
      name: 'cr_fc_s1',
      description: 'cr_fc_s1_d',
      crPurpose: 'cr_fc_s1_p',
      relation: 'get',
    }, {
      id: 1,
      name: 'cr_fc_s2',
      description: 'cr_fc_s2_d',
      crPurpose: 'cr_fc_s2_p',
      relation: 'keep',
    }, {
      id: 2,
      name: 'cr_fc_s3',
      description: 'cr_fc_s3_d',
      crPurpose: 'cr_fc_s3_p',
      relation: 'grow',
    }],
    [BMC_STAGES.FREE]: [{
      id: 0,
      name: 'cr_f_s1',
      description: 'cr_f_s1_d',
      crPurpose: 'cr_f_s1_p',
      relation: 'get',
    }, {
      id: 1,
      name: 'cr_f_s2',
      description: 'cr_f_s2_d',
      crPurpose: 'cr_f_s2_p',
      relation: 'keep',
    }, {
      id: 2,
      name: 'cr_f_s3',
      description: 'cr_f_s3_d',
      crPurpose: 'cr_f_s3_p',
      relation: 'grow',
    }],
  },


  [BMC_BLOCKS.KEY_ACTIVITIES]: {
    [BMC_STAGES.OBSERVATIONAL]: [{
      id: 0,
      name: 'ka_o_s1',
      description: 'ka_o_s1_d',
    }, {
      id: 1,
      name: 'ka_o_s2',
      description: 'ka_o_s2_d',
    }],
    [BMC_STAGES.FIRST_USER]: [{
      id: 0,
      name: 'ka_fu_s1',
      description: 'ka_fu_s1_d',
    }, {
      id: 1,
      name: 'ka_fu_s2',
      description: 'ka_fu_s2_d',
    }],
    [BMC_STAGES.FIRST_GROUP]: [{
      id: 0,
      name: 'ka_fg_s1',
      description: 'ka_fg_s1_d',
    }, {
      id: 1,
      name: 'ka_fg_s2',
      description: 'ka_fg_s2_d',
    }, {
      id: 2,
      name: 'ka_fg_s3',
      description: 'ka_fg_s3_d',
    }],
    [BMC_STAGES.FOCUS_GROUP]: [{
      id: 0,
      name: 'ka_fcg_s1',
      description: 'ka_fcg_s1_d',
    }, {
      id: 1,
      name: 'ka_fcg_s2',
      description: 'ka_fcg_s2_d',
    }],
    [BMC_STAGES.KNOW_HOW]: [{
      id: 0,
      name: 'ka_kh_s1',
      description: 'ka_kh_s1_d',
    }, {
      id: 1,
      name: 'ka_kh_s2',
      description: 'ka_kh_s2_d',
    }],
    [BMC_STAGES.EARLY_ADOPTERS]: [{
      id: 0,
      name: 'ka_ea_s1',
      description: 'ka_ea_s1_d',
    }, {
      id: 1,
      name: 'ka_ea_s2',
      description: 'ka_ea_s2_d',
    }],
    [BMC_STAGES.FIRST_CLIENT]: [{
      id: 0,
      name: 'ka_fc_s1',
      description: 'ka_fc_s1_d',
    }, {
      id: 1,
      name: 'ka_fc_s2',
      description: 'ka_fc_s2_d',
    }, {
      id: 2,
      name: 'ka_fc_s3',
      description: 'ka_fc_s3_d',
    }],
    [BMC_STAGES.FREE]: [{
      id: 0,
      name: 'ka_f_s1',
      description: 'ka_f_s1_d',
    }, {
      id: 1,
      name: 'ka_f_s2',
      description: 'ka_f_s2_d',
    }, {
      id: 2,
      name: 'ka_f_s3',
      description: 'ka_f_s3_d',
    }],
  },


  [BMC_BLOCKS.KEY_RESOURCES]: {
    [BMC_STAGES.OBSERVATIONAL]: [{
      id: 0,
      name: 'kr_o_s1',
      description: 'kr_o_s1_d',
    }, {
      id: 1,
      name: 'kr_o_s2',
      description: 'kr_o_s2_d',
    }],
    [BMC_STAGES.FIRST_USER]: [{
      id: 0,
      name: 'kr_fu_s1',
      description: 'kr_fu_s1_d',
    }, {
      id: 1,
      name: 'kr_fu_s2',
      description: 'kr_fu_s2_d',
    }],
    [BMC_STAGES.FIRST_GROUP]: [{
      id: 0,
      name: 'kr_fg_s1',
      description: 'kr_fg_s1_d',
    }, {
      id: 1,
      name: 'kr_fg_s2',
      description: 'kr_fg_s2_d',
    }],
    [BMC_STAGES.FOCUS_GROUP]: [{
      id: 0,
      name: 'kr_fcg_s1',
      description: 'kr_fcg_s1_d',
    }, {
      id: 1,
      name: 'kr_fcg_s2',
      description: 'kr_fcg_s2_d',
    }],
    [BMC_STAGES.KNOW_HOW]: [{
      id: 0,
      name: 'kr_kh_s1',
      description: 'kr_kh_s1_d',
    }, {
      id: 1,
      name: 'kr_kh_s2',
      description: 'kr_kh_s2_d',
    }],
    [BMC_STAGES.EARLY_ADOPTERS]: [{
      id: 0,
      name: 'kr_ea_s1',
      description: 'kr_ea_s1_d',
    }, {
      id: 1,
      name: 'kr_ea_s2',
      description: 'kr_ea_s2_d',
    }],
    [BMC_STAGES.FIRST_CLIENT]: [{
      id: 0,
      name: 'kr_fc_s1',
      description: 'kr_fc_s1_d',
    }, {
      id: 1,
      name: 'kr_fc_s2',
      description: 'kr_fc_s2_d',
    }],
    [BMC_STAGES.FREE]: [{
      id: 0,
      name: 'kr_f_s1',
      description: 'kr_f_s1_d',
    }, {
      id: 1,
      name: 'kr_f_s2',
      description: 'kr_f_s2_d',
    }],
  },


  [BMC_BLOCKS.KEY_PARTNERS]: {
    [BMC_STAGES.OBSERVATIONAL]: [{
      id: 0,
      name: 'kep_o_s1',
      description: 'kep_o_s1_d',
      utility: 'kep_o_s1_u',
    }, {
      id: 1,
      name: 'kep_o_s2',
      description: 'kep_o_s2_d',
      utility: 'kep_o_s2_u',
    }],
    [BMC_STAGES.FIRST_USER]: [{
      id: 0,
      name: 'kep_fu_s1',
      description: 'kep_fu_s1_d',
      utility: 'kep_fu_s1_u',
    }],
    [BMC_STAGES.FIRST_GROUP]: [{
      id: 0,
      name: 'kep_fg_s1',
      description: 'kep_fg_s1_d',
      utility: 'kep_fg_s1_u',
    }, {
      id: 1,
      name: 'kep_fg_s2',
      description: 'kep_fg_s2_d',
      utility: 'kep_fg_s2_u',
    }],
    [BMC_STAGES.FOCUS_GROUP]: [{
      id: 0,
      name: 'kep_fcg_s1',
      description: 'kep_fcg_s1_d',
      utility: 'kep_fcg_s1_u',
    }, {
      id: 1,
      name: 'kep_fcg_s2',
      description: 'kep_fcg_s2_d',
      utility: 'kep_fcg_s2_u',
    }],
    [BMC_STAGES.KNOW_HOW]: [{
      id: 0,
      name: 'kep_kh_s1',
      description: 'kep_kh_s1_d',
      utility: 'kep_kh_s1_u',
    }],
    [BMC_STAGES.EARLY_ADOPTERS]: [{
      id: 0,
      name: 'kep_ea_s1',
      description: 'kep_ea_s1_d',
      utility: 'kep_ea_s1_u',
    }, {
      id: 1,
      name: 'kep_ea_s2',
      description: 'kep_ea_s2_d',
      utility: 'kep_ea_s2_u',
    }],
    [BMC_STAGES.FIRST_CLIENT]: [{
      id: 0,
      name: 'kep_fc_s1',
      description: 'kep_fc_s1_d',
      utility: 'kep_fc_s2_u',
    }, {
      id: 1,
      name: 'kep_fc_s2',
      description: 'kep_fc_s2_d',
      utility: 'kep_fc_s2_u',
    }],
    [BMC_STAGES.FREE]: [{
      id: 0,
      name: 'kep_f_s1',
      description: 'kep_f_s1_d',
      utility: 'kep_f_s1_u',
    }, {
      id: 1,
      name: 'kep_f_s2',
      description: 'kep_f_s2_d',
      utility: 'kep_f_s2_u',
    }],
  },


  [BMC_BLOCKS.COST_STRUCTURE]: {
    [BMC_STAGES.OBSERVATIONAL]: [{
      id: 0,
      name: 'cos_o_s1',
      description: 'cos_o_s1_d',
    }, {
      id: 1,
      name: 'cos_o_s2',
      description: 'cos_o_s2_d',
    }],
    [BMC_STAGES.FIRST_USER]: [{
      id: 0,
      name: 'cos_fu_s1',
      description: 'cos_fu_s1_d',
    }],
    [BMC_STAGES.FIRST_GROUP]: [{
      id: 0,
      name: 'cos_fg_s1',
      description: 'cos_fg_s1_d',
    }, {
      id: 1,
      name: 'cos_fg_s2',
      description: 'cos_fg_s2_d',
    }, {
      id: 2,
      name: 'cos_fg_s3',
      description: 'cos_fg_s3_d',
    }],
    [BMC_STAGES.FOCUS_GROUP]: [{
      id: 0,
      name: 'cos_fcg_s1',
      description: 'cos_fcg_s1_d',
    }],
    [BMC_STAGES.KNOW_HOW]: [{
      id: 0,
      name: 'cos_kh_s1',
      description: 'cos_kh_s1_d',
    }],
    [BMC_STAGES.EARLY_ADOPTERS]: [{
      id: 0,
      name: 'cos_ea_s1',
      description: 'cos_ea_s1_d',
    }, {
      id: 1,
      name: 'cos_ea_s2',
      description: 'cos_ea_s2_d',
    }],
    [BMC_STAGES.FIRST_CLIENT]: [{
      id: 0,
      name: 'cos_fc_s1',
      description: 'cos_fc_s1_d',
    }],
    [BMC_STAGES.FREE]: [{
      id: 0,
      name: 'cos_f_s1',
      description: 'cos_f_s1_d',
    }, {
      id: 1,
      name: 'cos_f_s2',
      description: 'cos_f_s2_d',
    }, {
      id: 2,
      name: 'cos_f_s3',
      description: 'cos_f_s3_d',
    }],
  },


  [BMC_BLOCKS.REVENUE_STREAMS]: {
    [BMC_STAGES.OBSERVATIONAL]: [{
      id: 0,
      name: 'rs_o_s1',
      description: 'rs_o_s1_d',
    }, {
      id: 1,
      name: 'rs_o_s2',
      description: 'rs_o_s2_d',
    }],
    [BMC_STAGES.FIRST_USER]: [{
      id: 0,
      name: 'rs_fu_s1',
      description: 'rs_fu_s1_d',
    }, {
      id: 1,
      name: 'rs_fu_s2',
      description: 'rs_fu_s2_d',
    }, {
      id: 2,
      name: 'rs_fu_s3',
      description: 'rs_fu_s3_d',
    }],
    [BMC_STAGES.FIRST_GROUP]: [{
      id: 0,
      name: 'rs_fg_s1',
      description: 'rs_fg_s1_d',
    }, {
      id: 1,
      name: 'rs_fg_s2',
      description: 'rs_fg_s2_d',
    }, {
      id: 2,
      name: 'rs_fg_s3',
      description: 'rs_fg_s3_d',
    }],
    [BMC_STAGES.FOCUS_GROUP]: [{
      id: 0,
      name: 'rs_fcg_s1',
      description: 'rs_fcg_s1_d',
    }, {
      id: 1,
      name: 'rs_fcg_s2',
      description: 'rs_fcg_s2_d',
    }, {
      id: 2,
      name: 'rs_fcg_s3',
      description: 'rs_fcg_s3_d',
    }],
    [BMC_STAGES.KNOW_HOW]: [{
      id: 0,
      name: 'rs_kh_s1',
      description: 'rs_kh_s1_d',
    }, {
      id: 1,
      name: 'rs_kh_s2',
      description: 'rs_kh_s2_d',
    }],
    [BMC_STAGES.EARLY_ADOPTERS]: [{
      id: 0,
      name: 'rs_ea_s1',
      description: 'rs_ea_s1_d',
    }, {
      id: 1,
      name: 'rs_ea_s2',
      description: 'rs_ea_s2_d',
    }],
    [BMC_STAGES.FIRST_CLIENT]: [{
      id: 0,
      name: 'rs_fc_s1',
      description: 'rs_fc_s1_d',
    }, {
      id: 1,
      name: 'rs_fc_s2',
      description: 'rs_fc_s2_d',
    }],
    [BMC_STAGES.FREE]: [{
      id: 0,
      name: 'rs_f_s1',
      description: 'rs_f_s1_d',
    }, {
      id: 1,
      name: 'rs_f_s2',
      description: 'rs_f_s2_d',
    }],


  },


  /*


    [BMC_BLOCKS.KEY_PROPOSITIONS]: {
        [BMC_STAGES.OBSERVATIONAL]: [{
            id: 0,
            name: 'kp_o_s1',
            description: 'kp_o_s1_d'
        }, {
            id: 1,
            name: 'kp_o_s2',
            description: 'kp_o_s2_d'
        }],
        [BMC_STAGES.FIRST_USER]: [{
            id: 0,
            name: 'kp_fu_s1',
            description: 'kp_fu_s1_d'
        }, {
            id: 1,
            name: 'kp_fu_s2',
            description: 'kp_fu_s2_d'
        }],
        [BMC_STAGES.FIRST_GROUP]: [{
            id: 0,
            name: 'kp_fg_s1',
            description: 'kp_fg_s1_d'
        }, {
            id: 1,
            name: 'kp_fg_s2',
            description: 'kp_fg_s2_d'
        }],
        [BMC_STAGES.FOCUS_GROUP]: [{
            id: 0,
            name: 'kp_fcg_s1',
            description: 'kp_fcg_s1_d'
        }, {
            id: 1,
            name: 'kp_fcg_s2',
            description: 'kp_fcg_s2_d'
        }],
        [BMC_STAGES.KNOW_HOW]: [{
            id: 0,
            name: 'kp_kh_s1',
            description: 'kp_kh_s1_d'
        }, {
            id: 1,
            name: 'kp_kh_s2',
            description: 'kp_kh_s2_d'
        }],
        [BMC_STAGES.EARLY_ADOPTERS]: [{
            id: 0,
            name: 'kp_ea_s1',
            description: 'kp_ea_s1_d'
        }, {
            id: 1,
            name: 'kp_ea_s2',
            description: 'kp_ea_s2_d'
        }],
        [BMC_STAGES.FIRST_CLIENT]: [{
            id: 0,
            name: 'kp_fc_s1',
            description: 'kp_fc_s1_d'
        }, {
            id: 1,
            name: 'kp_fc_s2',
            description: 'kp_fc_s2_d'
        }],
        [BMC_STAGES.FREE]: [{
            id: 0,
            name: 'kp_f_s1',
            description: 'kp_f_s1_d'
        }, {
            id: 1,
            name: 'kp_f_s2',
            description: 'kp_f_s2_d'
        }],
    },


        [BMC_BLOCKS.CUSTOMER_SEGMENTS]: {
            [BMC_STAGES.OBSERVATIONAL]: [{
                id: 0,
                name: 'cs_o_s1',
                description: 'cs_o_s1_d'
            }, {
                id: 1,
                name: 'cs_o_s2',
                description: 'cs_o_s2_d'
            }],
            [BMC_STAGES.FIRST_USER]: [{
                id: 0,
                name: 'cs_fu_s1',
                description: 'cs_fu_s1_d'
            }, {
                id: 1,
                name: 'cs_fu_s2',
                description: 'cs_fu_s2_d'
            }],
            [BMC_STAGES.FIRST_GROUP]: [{
                id: 0,
                name: 'cs_fg_s1',
                description: 'cs_fg_s1_d'
            }, {
                id: 1,
                name: 'cs_fg_s2',
                description: 'cs_fg_s2_d'
            }],
            [BMC_STAGES.FOCUS_GROUP]: [{
                id: 0,
                name: 'cs_fcg_s1',
                description: 'cs_fcg_s1_d'
            }, {
                id: 1,
                name: 'cs_fcg_s2',
                description: 'cs_fcg_s2_d'
            }],
            [BMC_STAGES.KNOW_HOW]: [{
                id: 0,
                name: 'cs_kh_s1',
                description: 'cs_kh_s1_d'
            }, {
                id: 1,
                name: 'cs_kh_s2',
                description: 'cs_kh_s2_d'
            }],
            [BMC_STAGES.EARLY_ADOPTERS]: [{
                id: 0,
                name: 'cs_ea_s1',
                description: 'cs_ea_s1_d'
            }, {
                id: 1,
                name: 'cs_ea_s2',
                description: 'cs_ea_s2_d'
            }],
            [BMC_STAGES.FIRST_CLIENT]: [{
                id: 0,
                name: 'cs_fc_s1',
                description: 'cs_fc_s1_d'
            }, {
                id: 1,
                name: 'cs_fc_s2',
                description: 'cs_fc_s2_d'
            }],
            [BMC_STAGES.FREE]: [{
                id: 0,
                name: 'cs_f_s1',
                description: 'cs_f_s1_d'
            }, {
                id: 1,
                name: 'cs_f_s2',
                description: 'cs_f_s2_d'
            }],
        },
        */

};


export {
  SUGGESTS,
  VISION_SUGGESTS,
};
